import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { ArrowRight } from 'lucide-react';

export const Footer = () => {
  const { language } = useLanguage();
  const WHATSAPP = "https://wa.me/529841585732?text=Hola%2C%20quiero%20agendar%20una%20consulta%20gratuita%20con%20Marea%20Riviera";

  return (
    <footer className="bg-[#0A2235] pt-24 pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-16 lg:px-24">
        {/* Large brand text like Aurven footer */}
        <div className="overflow-hidden mb-16">
          <p className="font-playfair text-[clamp(4rem,12vw,10rem)] text-[#2BBFBF]/15 leading-none tracking-tight italic select-none notranslate" translate="no">
            marea riviera
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12 mb-16">
          <div>
            <p className="font-playfair text-2xl md:text-3xl text-[#FAFAF7] leading-snug mb-6">
              {language === 'es'
                ? 'Propiedades que se pagan solas en la Riviera Maya.'
                : 'Properties that pay for themselves in the Riviera Maya.'}
            </p>
            <a href={WHATSAPP} target="_blank" rel="noopener noreferrer" className="inline-flex items-center group">
              <span className="font-inter text-[#FAFAF7] text-sm tracking-wider border border-[#FAFAF7]/20 px-5 py-2.5 rounded-l-full group-hover:bg-[#FAFAF7]/10 transition-colors">
                {language === 'es' ? 'Contáctanos' : 'Get in touch'}
              </span>
              <span className="bg-[#FAFAF7]/10 border border-[#FAFAF7]/20 border-l-0 p-2.5 rounded-r-full group-hover:bg-[#2BBFBF] transition-colors">
                <ArrowRight className="w-4 h-4 text-[#FAFAF7]" />
              </span>
            </a>
          </div>

          <div>
            <span className="inline-block font-inter text-xs uppercase tracking-[0.25em] text-[#FAFAF7]/40 border border-[#FAFAF7]/10 px-3 py-1 rounded-sm mb-6">
              {language === 'es' ? 'Navegación' : 'Navigation'}
            </span>
            <ul className="space-y-3 font-inter text-[#FAFAF7]/70 text-sm">
              <li><a href="#properties" className="hover:text-[#2BBFBF] transition-colors">{language === 'es' ? 'Propiedades' : 'Properties'}</a></li>
              <li><a href="#casas" className="hover:text-[#2BBFBF] transition-colors">{language === 'es' ? 'Casas' : 'Houses'}</a></li>
              <li><a href="#calculator" className="hover:text-[#2BBFBF] transition-colors">Cash Flow</a></li>
              <li><a href="#zones" className="hover:text-[#2BBFBF] transition-colors">{language === 'es' ? 'Zonas' : 'Zones'}</a></li>
              <li><a href="#faq" className="hover:text-[#2BBFBF] transition-colors">FAQ</a></li>
            </ul>
          </div>

          <div>
            <span className="inline-block font-inter text-xs uppercase tracking-[0.25em] text-[#FAFAF7]/40 border border-[#FAFAF7]/10 px-3 py-1 rounded-sm mb-6">
              {language === 'es' ? 'Contacto' : 'Contact'}
            </span>
            <ul className="space-y-3 font-inter text-[#FAFAF7]/70 text-sm">
              <li>mareariviera@outlook.com</li>
              <li>+52 984 158 5732</li>
              <li>Playa del Carmen, Quintana Roo, MX</li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#FAFAF7]/10 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <div className="flex items-center gap-4">
            <p className="font-inter text-[#FAFAF7]/30 text-xs"><span className="notranslate" translate="no">© 2026 Marea Riviera.</span> {language === 'es' ? 'Todos los derechos reservados.' : 'All rights reserved.'}</p>
            <Link to="/privacidad" className="font-inter text-[#FAFAF7]/30 text-xs hover:text-[#2BBFBF] transition-colors" data-testid="footer-privacy-link">{language === 'es' ? 'Política de Privacidad' : 'Privacy Policy'}</Link>
          </div>
          <div className="flex items-center gap-4">
            <a href="https://www.instagram.com/mareariviera/" target="_blank" rel="noopener noreferrer" className="text-[#FAFAF7]/40 hover:text-[#2BBFBF] transition-colors" data-testid="footer-instagram">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
            </a>
            <a href="https://www.facebook.com/mareariviera/" target="_blank" rel="noopener noreferrer" className="text-[#FAFAF7]/40 hover:text-[#2BBFBF] transition-colors" data-testid="footer-facebook">
              <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
